import { render } from "./EditVerifikasiLiveig.vue?vue&type=template&id=7666e547"
import script from "./EditVerifikasiLiveig.vue?vue&type=script&lang=js"
export * from "./EditVerifikasiLiveig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__